import React from "react";
import ContractEnergyDTO from "features/contracts/dtos/ContractEnergyDTO";
import ContractFullDTO from "features/contracts/dtos/ContractFullDTO";
import ContractDetailLayoutPage from "./ContractDetailLayoutPage";
import ConsumptionHistorySection from "features/contracts/sections/ConsumptionHistorySection";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { useTranslation } from "react-i18next";
import MeasuredData from "features/shared/components/measuredData/MeasuredData";
import { Consumption_ConsumptionRealDetail } from "data/endpoints";
import { getQueryParams } from "features/shared/helpers/queryParams";
import { getDownloadUrlByContractType, hasMeasuredData } from "features/shared/components/measuredData/measuredDataHelper";
import HeatConsumptionHistorySection from "../sections/HeatConsumptionHistorySection";

interface Props {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const ConsumptionHistoryPage = ({ contract, contractEnergy }: Props) => {
  // translations
  const tLabels = useTranslation(["shared\\moduleNames"]).t;
  const tContacts = useTranslation("contracts\\contracts").t;

  // helpers
  const getBreadcrumbTitle = () => {
    if (contract.isProduction) {
      return tLabels("productionHistoryPage.title");
    } else {
      return tLabels("consumptionHistoryPage.title");
    }
  };

  // sub-renders
  const renderConsumptionSection = (): JSX.Element => { 
    if (contract.commodityDetail === "HeatCustomer") {
      return (
        <HeatConsumptionHistorySection 
          contractId={contract.contractId!}
          effectiveDate={contract.effectiveDate!}
          terminationDate={contract.terminationDate!}
        />
      );
    } else {
      return (
        <ConsumptionHistorySection
          contract={contract}
          meterType={contractEnergy.meterType!}
        />
      );
    }
  }

  // render
  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[{ text: getBreadcrumbTitle() }]}
    >
      {renderConsumptionSection()} 
      <RenderWrapper
        isVisible={() =>
          hasMeasuredData(contract.contractType!, contractEnergy.meterType!)
        }
      >
        <MeasuredData 
          title={tContacts("consumptionHistoryPage.profileData")}
          commodityDetail={contract.commodityDetail!}
          from={contract.effectiveDate!}
          to={contract.terminationDate!}
          graphDataUrl={Consumption_ConsumptionRealDetail}
          downloadDataUrl={getDownloadUrlByContractType(contract.contractType!, contract.isProduction, contractEnergy.meterType)}
          identificationParams={getQueryParams("ContractId", contract.contractId!)}
          isProduction={contract.isProduction}
        />
      </RenderWrapper>
    </ContractDetailLayoutPage>
  );
};

export default ConsumptionHistoryPage;
